import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { NOTIFICATIONS } from '../../routes/routeConstants';
import { InternalNavLink } from '../Link/Link';
import NotificationIcon from '../Icons/NotificationIcon';
import useMiniLoad from '../../hooks/dashboard/dashboardLoading/useMiniLoad';
import { LoadingOutlined } from '@ant-design/icons';
import { useAppSelector } from '../../redux/store';

const NotificationIndicator = () => {
  const { authData } = useAppSelector((state) => state.auth);

  const { loading, getMiniLoadData } = useMiniLoad();

  useEffect(() => {
    if (authData?.id) {
      getMiniLoadData();
    }
    // eslint-disable-next-line
  }, [authData?.id]);

  const notifications = useAppSelector(
    (state) => state.notifications.notifications
  );

  if (loading) {
    return (
      <IconWrapper className="loading">
        <LoadingOutlined />
      </IconWrapper>
    );
  }

  return (
    <IconWrapper>
      <InternalNavLink to={`/${NOTIFICATIONS}`}>
        <NotificationIcon />
      </InternalNavLink>
      {notifications?.length > 0 && (
        <NotificationsCount>{notifications?.length}</NotificationsCount>
      )}
    </IconWrapper>
  );
};

export default NotificationIndicator;

const IconWrapper = styled.div`
  position: relative;
  &:hover {
    cursor: pointer;
  }

  &.loading {
    margin-top: 0.5rem;
  }
`;

const NotificationsCount = styled.p`
  position: absolute;
  top: -10px;
  color: white;
  background-color: red;
  font-size: 10px;
  font-weight: 600;
  border-radius: 50%;
  width: 1.3rem;
  height: 1.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
